import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GetApps } from 'nallian-shared-ui/lib/selectors';
import { Flex, ExternalLink } from 'nallian-shared-ui/lib/components';
import { createShortAppName } from 'nallian-shared-ui/lib/lib/createShortAppName';
import {
  AppLink,
  CardFlex,
  ImageCard,
  NonImageCard,
  APP_TAG_IMAGE_MAP,
} from 'nallian-shared-ui/lib/layout/UserApps';
import FormHeader from '../../app/components/FormHeader';

const MyAppsOverview = () => {
  const { t } = useTranslation();

  const myApps = useSelector(GetApps);

  return (
    <Flex fluid direction="column" margin="1.5rem 0 2rem">
      {myApps?.map(a => (
        <Flex fluid direction="column" key={a.community.id} margin="0 0 0.5rem 0">
          <FormHeader content={myApps?.length === 1 ? t('myApps') : a.community.name} />
          <Flex fluid wrap="wrap">
            {a.apps.map(app => (
              <CardFlex
                big
                direction="column"
                alignItems="center"
                key={`${a.community.id}_${app.id}`}
              >
                {app.url ? (
                  <ExternalLink
                    className="link"
                    href={`${/^([a-z]+:){0,1}\/\//.test(app.url) ? '' : '//'}${app.url.replace(
                      '[EnvironmentUrl]',
                      `${window.location.host}/`
                    )}`}
                  >
                    {APP_TAG_IMAGE_MAP[app.appTag] ? (
                      <ImageCard raised image={APP_TAG_IMAGE_MAP[app.appTag]} />
                    ) : (
                      <NonImageCard className="ui card" big>
                        {app.shortName || createShortAppName(app.name)}
                      </NonImageCard>
                    )}
                    <AppLink className="link">{app.name}</AppLink>
                  </ExternalLink>
                ) : (
                  <>
                    {APP_TAG_IMAGE_MAP[app.appTag] ? (
                      <ImageCard raised image={APP_TAG_IMAGE_MAP[app.appTag]} />
                    ) : (
                      <NonImageCard className="ui card" big>
                        {app.shortName || createShortAppName(app.name)}
                      </NonImageCard>
                    )}
                    <AppLink>{app.name}</AppLink>
                  </>
                )}
              </CardFlex>
            ))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default MyAppsOverview;
